module.exports = __webpack_public_path__ + "img/ep-flocon.7300e418.png";